"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSceneSurfaceData = void 0;
var equality_1 = require("@wry/equality");
var react_1 = require("react");
var renderer_provider_1 = require("../renderer-provider");
var load_scene_surface_data_1 = require("./load-scene-surface-data");
var useSceneSurfaceData = function (scene) {
    var _a = (0, renderer_provider_1.useRendererContext)(), resourceContext = _a.resourceContext, getState = _a.getState;
    var state = (0, react_1.useRef)({ type: 'LOADING' });
    var _b = __read((0, react_1.useReducer)(function (version) { return version + 1; }, 0), 2), version = _b[0], incrementVersion = _b[1];
    var currentVersion = (0, react_1.useRef)(version);
    var lastScene = (0, react_1.useRef)(null);
    var setState = (0, react_1.useCallback)(function (newState, version) {
        /* istanbul ignore else: difficult to test */
        if (version === currentVersion.current) {
            state.current = newState;
            incrementVersion();
        }
    }, []);
    (0, react_1.useLayoutEffect)(function () {
        if ((0, equality_1.equal)(scene, lastScene.current)) {
            return;
        }
        lastScene.current = scene;
        currentVersion.current = version;
        var newState = (0, load_scene_surface_data_1.loadSceneSurfaceData)(scene, resourceContext);
        if (newState instanceof Promise) {
            setState({ type: 'LOADING' }, version);
            newState
                .then(function (loadedState) {
                setState(loadedState, version);
            })
                .catch(function (error) {
                setState({ type: 'ERROR', message: error.message }, version);
            });
        }
        else {
            setState(newState, version);
        }
    }, [scene]);
    var providerState = getState();
    if (providerState.type !== 'LOADED') {
        return providerState;
    }
    return state.current;
};
exports.useSceneSurfaceData = useSceneSurfaceData;
